//Jquery element animations on scroll

(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {
    
      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;
    
    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };
    
})(jQuery);
(function($) {
  var host = window.location.host;

  $('.mega-menu-panel').hover(
       function(){ $('.top-bar').addClass('active') },
       function(){ $('.top-bar').removeClass('active') }
  )

  $('.main .mega-menu-panel').hover(
       function(){ $('#logoImg').attr('src', '/wp-content/themes/conviva2021/assets/images/conviva-logo-white.svg');
       $('#searchIcon').attr('src', '/wp-content/themes/conviva2021/assets/images/search-icon-white.svg') },
       function(){ $('#logoImg').attr('src', '/wp-content/themes/conviva2021/assets/images/conviva-logo.svg'),
        $('#searchIcon').attr('src', '/wp-content/themes/conviva2021/assets/images/search-icon.svg')}
  )

  $(".streaming").hover(function () {
      $(".text").removeClass("active");
      $('#streaming').addClass("active");   
  });
  $(".viewer").hover(function () {
      $(".text").removeClass("active");
      $('#viewer').addClass("active");   
  });
  $(".social").hover(function () {
      $(".text").removeClass("active");
      $('#social').addClass("active");   
  });
  $(".advertising").hover(function () {
      $(".text").removeClass("active");
      $('#advertising').addClass("active");   
  });
  $(".experience").hover(function () {
      $(".text").removeClass("active");
      $('#experience').addClass("active");   
  });
  $(".integrations").hover(function () {
      $(".text").removeClass("active");
      $('#integrations').addClass("active");   
  });

  $('.reveal').on('open.zf.reveal', function(event) {
    document.documentElement.style.scrollBehavior = "initial";
  });
  $('.reveal').on('closed.zf.reveal', function(event) {
    document.documentElement.style.scrollBehavior = "smooth";
  });
    

  $('.feature-tabs .tabs').on('change.zf.tabs', function() {

    $('html, body').animate({
      scrollTop: $('.features-section .block-title').offset().top - 20
    }, '300');
  });

  $('.feature-tabs .accordion').on('down.zf.accordion', function() {

    $('html, body').animate({
      scrollTop: $('.features-section .block-title').offset().top - 20
    }, '300');
  });
  
  var rotate = function(container) {
    var activeElement = $(container).find('.active');
    var images = $(container).find('.logo-item').toArray();

    // remove active class from any element
    $(container).find('.logo-item').removeClass('active');

    // add fade-out class to currently active element
    activeElement.addClass('fade-out');
    // remove fade-out class after the element transition time, make
    // sure this matches the transition interval on .logo-item
    setTimeout(function(){
      activeElement.removeClass('fade-out');
    }, 1000);

    // add active class to element after currently active element 
    // or to first element if the last element was active
    var isNextElement = !!activeElement.next().length;
    if (isNextElement) {
      activeElement.next().addClass('active');
    } else {
      $(images[0]).addClass('active');
    }
  }

  $('.logo-container').each(function(i, container) {
    var dataDelay = $(container).attr('data-delay');
    var dataInterval = $(container).attr('data-interval');
    var delay = dataDelay 
      ? dataDelay * 1000 
      : 0;
    var interval = dataInterval
      ? dataInterval * 1000 
      : 17500;

    setTimeout(function() {
      rotate(container);
      
      setInterval(function() {
        rotate(container);
      }, interval);
    }, delay);
  })

var lottiePlayer = document.getElementsByTagName("lottie-player");

$(".animation-container").on({
    mouseenter: function () {
        $(this).find(lottiePlayer)[0].play();
    },
    mouseleave: function () {
        $(this).find(lottiePlayer)[0].stop();
    }
});
})(jQuery);

function linkBoxes() {
  var boxes = document.querySelectorAll(".post-card-block");

  boxes.forEach(function (box) {
    var link = box.querySelector("a");

    if (link) {
      var url = link.getAttribute("href");
      var linkTarget = link.getAttribute('target');
      box.addEventListener("click", function () {
        if (linkTarget === "_blank") {
          window.open(url, '_blank');
        } else {
        location.href = url;
        link.preventDefault;
        }
      });
      box.classList.add("linkify");
      link.addEventListener("focus", function () {
        box.classList.add("isfocused");
      });
      link.addEventListener("blur", function () {
        box.classList.remove("isfocused");
      });

 /* Inject CTA in to cards as visual affordance but hide from assistive tech announcements */
      // var ctaBlock = box.querySelector('.cta-container');
      // ctaBlock.insertAdjacentHTML("afterbegin", '<span class="tertiary-link" aria-hidden="true">Read more</span>');
    }
  });
}
document.addEventListener("DOMContentLoaded", function () {
  if ("querySelector" in document) {
    linkBoxes();
  }
});
